<script setup lang="ts">
import { PhxsgDivider } from '@sg/src/View/Components/Atoms/Divider';

interface Spec {
  left?: string;
  right?: string;
  slot?: string;
}

defineProps({
  specs: {
    type: Array as () => Spec[],
    default: () => [],
  },

  hideFirstDivider: {
    type: Boolean,
    default: false,
  },

  hideLastDivider: {
    type: Boolean,
    default: false,
  },

  dividerColor: {
    type: String,
    default: null,
  },

  animate: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div :class="['phxsg-specs-table']" v-bind="$attrs">
    <template v-for="(spec, index) in specs" :key="`${spec.left}-${spec.right}-${index}`">
      <PhxsgDivider
        v-if="index === 0 && !hideFirstDivider"
        :color="dividerColor"
        :class="{ 'phxsg-mask-reveal-to-right': animate }"
      />

      <div :class="['phxsg-specs-table__row', { 'phxsg-fade-in': animate }]">
        <template v-if="spec.slot">
          <slot :name="spec.slot" />
        </template>

        <template v-else>
          <span v-if="spec.left" class="phxsg-specs-table__row-left title-caption">
            {{ spec.left }}
          </span>

          <span v-if="spec.right" class="phxsg-specs-table__row-right title-caption">
            {{ spec.right }}
          </span>
        </template>

        <PhxsgDivider
          v-if="!(index === specs.length - 1 && hideLastDivider)"
          :color="dividerColor"
          :class="{ 'phxsg-mask-reveal-to-right': animate }"
        />
      </div>
    </template>
  </div>
</template>

<style src="./specs-table.css" />
